import { useTranslation } from 'react-i18next';
import { Skeleton } from 'antd';

import s from './PageStates.module.scss';

import type { FC } from 'react';

const SKELETON_ROW_COUNT = 5;
const SKELETON_COLUMNS = [
  'skeleton-col-task',
  'skeleton-col-patient',
  'skeleton-col-pod',
  'skeleton-col-priority',
  'skeleton-col-reporter',
  'skeleton-col-date',
  'skeleton-col-actions',
] as const;

const LoadingState: FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className={s['loading-container']}
      data-cy="loading-state"
      role="status"
      aria-live="polite"
      aria-label={t('tasksDashboard.loadingState.ariaLabel')}
    >
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
        <div key={i} className={s['skeleton-row']}>
          {SKELETON_COLUMNS.map((col) => (
            <Skeleton.Input key={col} active size="small" className={s[col]} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default LoadingState;
